export function Resume({ subscription }) {
  return (
    <div className="w-full">
      <p>Abonnement : {subscription.offer.TYPE_OFFER === "full" ? "Papier + numérique" : "Numérique"}</p>
      <p>Tarif : {subscription.offer?.DURATION} ({subscription.offer.TARIF_NOMBRE} numéros)</p>
      <p>Quantité : {subscription.copies}</p>
      <p className="mt-5">Prix : {(subscription.offer.TARIF_MONTANT * subscription.copies).toFixed(2)}{subscription.offer.CURRENCY}</p>
    </div>
  );
}